module.exports = __webpack_public_path__ + "img/player-outline.ae342421.svg";